<template>
    <ValidationProvider
        :vid="'vp' + name + index"
        :ref="name + index || label"
        tag="div"
        :rules="rules"
        :name="name + index || label"
        v-slot="{ errors, required, classes }"
        class="w-100 form-group form-floating"
    >
        <!--placeholder is mandatory for floating input to work, even if not shown-->
        <input
            class="form-control px-0"
            :class="classes"
            :id="name + index"
            :type="type"
            v-model="innerValue"
            :min="min"
            :max="max"
            :placeholder="label"
            :disabled="disabled"
        />

        <div v-if="append_name" class="input-group-append">
            <span class="input-group-text">{{ append_name }}</span>
        </div>
        <span class="invalid-feedback" v-html="errors[0]"></span>
        <label
            :for="name + index"
            class="px-0"
        >
            <slot v-if="!label"></slot>
            <span v-else v-html="label"></span>

            <b class="text-danger">{{ required ? "*" : "" }}</b>
        </label>
    </ValidationProvider>
</template>

<script>
    export default {
        name: "ValidationInput",
        props: {
            name: {
                type: String,
                default: "",
            },
            index: {
                type: String,
                default: "",
            },
            label: {
                type: String,
                default: "",
            },
            rules: {
                type: [Object, String],
                default: "",
            },
            placeholder: {
                type: String,
                default: "",
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: "text",
                validator(value) {
                    return [
                        "url",
                        "text",
                        "password",
                        "tel",
                        "search",
                        "number",
                        "email",
                    ].includes(value);
                },
            },
            value: {
                type: null,
                default: "",
            },
            append_name: {
                type: String,
                default: "",
            },
            min: {
                type: String | Number,
                default: "",
            },
            max: {
                type: String | Number,
                default: "",
            },
        },
        data: () => ({
            innerValue: "",
        }),
        watch: {
            innerValue(value) {
                this.$emit("input", value);
            },
            value(val) {
                if (val !== this.innerValue) {
                    this.innerValue = val;
                }
            },
        },
        created() {
            if (this.value) {
                this.innerValue = this.value;
            }
        },
    };
</script>

<style scoped lang="scss">
    input {
        border-top: 0;
        border-left: 0;
        border-right: 0;
    }
</style>
